import { render } from "./StepFour.vue?vue&type=template&id=6a0e75b0&scoped=true"
import script from "./StepFour.vue?vue&type=script&lang=js"
export * from "./StepFour.vue?vue&type=script&lang=js"

import "./StepFour.vue?vue&type=style&index=0&id=6a0e75b0&scoped=true&lang=css"

import exportComponent from "/var/www/extranet-sinistre-agemi/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0e75b0"]])

export default __exports__